import SpriteSymbol from "../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../shared/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-flow-arrow",
  "use": "icon-flow-arrow-usage",
  "viewBox": "0 0 20 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 36\" id=\"icon-flow-arrow\"><path d=\"M9.75 35V0M0 26l10 10 10-10\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol